import { AmoService } from '@amo-widget/services/AmoService';
import { snakeStore } from '@app/plugins/vuex-async-pagginate';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => AmoService.getList(params)
    }
  },
  true
);
